import '@/vendor/formstone';
import '@/vendor/modernizr-custom';
import Site from '@/base/Site';
import '@/base/page';
import { requireAll } from '@/helpers/utils';

if (!window.$ && window.jQuery) {
	window.$ = window.jQuery.noConflict();
}

requireAll(require.context('./base/', true, /\.js$/));
requireAll(require.context('./modules/', true, /\.js$/));

$(function () {
	Site.init('framework');
});
